export const isScrolledIntoView = (el?: Element | null, offset = 0): boolean => {
    if (!el) {
        return false;
    }

    const docViewTop = window.scrollY;
    const elemTop = el.getBoundingClientRect().top + docViewTop - offset;
    const elemBottom = el.getBoundingClientRect().bottom + docViewTop;

    return ((docViewTop <= elemBottom) && (docViewTop >= elemTop));
};

export const isElementInViewport = (el?: Element | null): boolean => {
    if (!el) {
        return false;
    } // Ensure the element exists

    const rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};
